﻿import { Button, cn, TooltipTrigger, TooltipContent, useSidebar, Tooltip } from 'shared-ui';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import * as React from 'react';
import { OrbitIconWrapper } from '@/components/app/OrbitIconWrapper.tsx';

export function OrbitSidebarTrigger({ className, onClick, ...props }: React.ComponentProps<typeof Button>) {
    const { toggleSidebar, state, isMobile, openMobile } = useSidebar();

    const isOpen = isMobile ? openMobile : state === 'expanded';
    const icon = isOpen ? PanelLeftClose : PanelLeftOpen;
    const tooltipLabel = isOpen ? 'Close' : 'Open';

    return (
        <Tooltip>
            <TooltipTrigger
                render={
                    <Button
                        data-sidebar="trigger"
                        data-slot="sidebar-trigger"
                        variant="ghost"
                        className={cn(
                            'h-auto w-auto cursor-pointer p-0 transition-[width,height,padding] hover:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0',
                            className,
                        )}
                        onClick={(event) => {
                            onClick?.(event);
                            toggleSidebar();
                        }}
                        {...props}
                    >
                        <OrbitIconWrapper icon={icon} hover="button" />
                        <span className="sr-only">Toggle Sidebar</span>
                    </Button>
                }
            ></TooltipTrigger>
            <TooltipContent side="right" align="center">
                {tooltipLabel}
            </TooltipContent>
        </Tooltip>
    );
}
